import { API_ROOT } from '../../config/config'
import { doGet } from './utils'

// const API_ROOT = 'http://localhost:9001/api'

export const getRedirectPageUrl = (type, id) => {
  // http://103.91.191.229:9000/api/redirect-page/info-path?type=AUDIT_IDINFO&id=9ECB6E7F-F7C1-46C9-94B9-36E6C771FDDC
  const url = `${API_ROOT}/redirect-page/info-path?type=${type}&id=${id}`
  return doGet(url)
}
